import { Navigate } from 'react-router-dom';
const AuthRoute = ({ children }) => {
  const token=localStorage.getItem("token");
  const roles=localStorage.getItem("roles")

  if (token) {
    if (roles === 'Admin') return <Navigate to="/admin/admin-dashboard" replace />;
    if (roles === 'Student') return <Navigate to="/student/student-dashboard" replace />;
  }

  return children;
};

export default AuthRoute;
